import { useUI } from '../contexts/UIContext';

export const useQueryError = () => {
  const { showToast } = useUI();

  const handleError = (error) => {
    console.error('Query Error:', error);
    
    // Manejo de errores de red
    if (!navigator.onLine) {
      showToast('No internet connection. Please check your network', 'error', 7000);
      return;
    }

    // Errores específicos de Supabase
    if (error?.code) {
      switch (error.code) {
        case 'PGRST116':
          showToast('Invalid API response format', 'error', 5000);
          return;
        case 'PGRST301':
          showToast('Database connection error', 'error', 5000);
          return;
        case '42501':
          showToast('You don\'t have permission to access this resource', 'error', 5000);
          return;
        default:
          if (error.code.startsWith('PGRST')) {
            showToast('Database error occurred', 'error', 5000);
            return;
          }
      }
    }

    // Errores de estado HTTP
    if (error?.status) {
      switch (error.status) {
        case 401:
          showToast('Authentication required. Please log in', 'error', 5000);
          break;
        case 403:
          showToast('You don\'t have permission to access this resource', 'error', 5000);
          break;
        case 404:
          showToast('The requested resource was not found', 'warning', 5000);
          break;
        case 429:
          showToast('Too many requests. Please try again later', 'error', 7000);
          break;
        case 500:
          showToast('Server error occurred. Please try again later', 'error', 5000);
          break;
        case 503:
          showToast('Service temporarily unavailable. Please try again later', 'error', 7000);
          break;
        default:
          if (error.status >= 500) {
            showToast('Server error occurred. Please try again later', 'error', 5000);
          } else if (error.status >= 400) {
            showToast('Request error occurred', 'error', 5000);
          }
      }
      return;
    }

    // Errores específicos de React Query
    if (error?.type === 'query') {
      switch (error.reason) {
        case 'stale':
          showToast('Data is outdated. Refreshing...', 'info', 3000);
          break;
        case 'cache-miss':
          showToast('Loading fresh data...', 'info', 3000);
          break;
        default:
          // No mostrar toast para otros tipos de errores de query (como cancelled)
          return;
      }
      return;
    }

    // Error genérico como último recurso
    showToast(
      error?.message || 'An unexpected error occurred',
      'error',
      5000
    );
  };

  return { handleError };
};